@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  <div class="flex align-items-center">
    <div
      [ngClass]="
        setCheckInStatus($.row.clt_chkin_access_status) == 'Granted'
          ? 'bg-green-400'
          : 'bg-red'
      "
      class="h-1rem w-1rem border-circle mr-2"
    ></div>
    <div>{{ setCheckInStatus($.row.clt_chkin_access_status) }}</div>
  </div>
}
